import React from 'react';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import Carousel, { Modal, ModalGateway, carouselComponents } from 'react-images';
import pageStore from 'stores/Page/IntegrationDetails/DetailsPageStore';

import * as api from 'Api';
import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';


@observer
class CustomContainer extends React.Component {
  render() {
    return (
      <div className="integration-screenshots-modal-wrapper">
        <carouselComponents.Container {...this.props}/>
      </div>
    );
  }
}


@observer
class ScreenshotsLightBox extends React.Component {
  render() {
    return (
      <ModalGateway>
        {pageStore.displayScreenshot ? (
          <Modal onClose={() => pageStore.toggleDisplayScreenshot()}>
            <Carousel
              views={pageStore.screenshotsViews}
              currentIndex={pageStore.screenshotIndex}
              components={{ Container: CustomContainer }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    );
  }
}


@observer
class MainAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getCategory = () => {
    const integration = pageStore.integration;
    const listing = integration.listing;

    let option = pageStore.categoryOptions.filter((option) => option.id === listing.categoryOptionId)[0];
    if (!option) return;
    return option.label;
  };

  render() {
    const integration = pageStore.integration;
    const listing = integration.listing;

    return (
      <div className="integration-attribute">
        <img className="integration-item-logo" src={listing.logoMedia.src} />
        <h1 className="integration-item-name">{integration.name}</h1>
        <div className="integration-item-category">{this.getCategory()}</div>
        <div className="integration-item-tagline">{listing.tagline}</div>
      </div>
    );
  }
}


@observer
class LinkAttributeItem extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { link } = this.props;
    return (
      <li><a href={link.urlWithUtm} className="integration-attribute-link" target="_blank" rel="nofollow noopener">{link.title}</a></li>
    );
  }
}


@observer
class LinksAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const integration = pageStore.integration;
    const listing = integration.listing;

    return (
      <div className="integration-attribute">
        <div className="integration-attribute-heading">Links</div>
        <ul className="integration-attribute-links">
          {listing.links.map((link) =>
            <LinkAttributeItem
              key={uniqueId()}
              link={link}
            />
          )}
        </ul>
      </div>
    );
  }
}

@observer
class DealAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const integration = pageStore.integration;
    const deal = integration.deal;
    if (!deal.id ||!deal.displayListing) return null;

    return (
      <div className="integration-attribute">
        <div className="integration-attribute-heading">Partner Deal</div>
        <div className="integration-attribute-desc deal-offer">{deal.offer}</div>

        <div className="redemption">
          <div className="redemption-title">How to Redeem?</div>
          <div className="redemption-desc">
            Partner deals can be only redeemed by OnVoard accounts with paid plans.<br/><br/>
            If you have an OnVoard account with paid plan, you can login and view redemption instructions below.
          </div>

          <a href={deal.redemptionLink} className="redemption-button" target="_blank" rel="nofollow noopener">View Redemption</a>
        </div>
      </div>
    );
  }
}

@observer
class Screenshot extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { screenshot, showScreenshot } = this.props;
    return (
      <div className="integration-screenshot">
        <img className="integration-screenshot-img" src={screenshot.media.src} onClick={showScreenshot} />
        <div className="integration-screenshot-desc">{screenshot.desc}</div>
      </div>
    );
  }
}


@observer
class IntegrationDetails extends React.Component {
  constructor (props) {
    super(props);
  }

  componentDidMount() {}

  showScreenshot = (idx) => {
    pageStore.toggleDisplayScreenshot();
    pageStore.setScreenshotIndex(idx);
  };

  render() {
    const integration = pageStore.integration;
    const listing = integration.listing;

    return (
      <div className="integration-details">
        <div className="integration-breadcrumbs">
          <a href="/integrations" className="integration-breadcrumb">
            <Icon.Bp icon="chevron-left" />
            <div className="integration-breadcrumb-text">Integrations</div>
          </a>
        </div>

        <div className="integration-details-main">
          <div className="integration-attributes">
            <MainAttribute />
            <LinksAttribute />
            <DealAttribute />
          </div>

          <div className="integration-content">
            <div className="integration-article">{listing.desc}</div>

            {listing.screenshots.length > 0 ? (
              <div className="integration-screenshots">
                <h3>Screenshots</h3>
                <div className="screenshots-grid">
                  {listing.screenshots.map((screenshot, idx) =>
                    <Screenshot
                      key={idx}
                      screenshot={screenshot}
                      showScreenshot={() => this.showScreenshot(idx)}
                    />
                  )}
                </div>
              </div>
            ): null}

          </div>

        </div>
        <ScreenshotsLightBox />
      </div>
    );
  }
}



export default IntegrationDetails;
